import React from 'react';

import { BADGE_BASE } from './badgeBase';

// "From file" marker for a List Management column that comes straight from
// the imported CSV (#974). Display-only, never written to the CRM.
export default function SourceColumnBadge({ className = '', ...rest }) {
    return (
        <span
            data-testid="source-column-badge"
            aria-label="Column from the imported file"
            className={`${BADGE_BASE} bg-[#FFF4DC] text-[#8A6516] dark:bg-[#3D3016] dark:text-[#F0C970] ${className}`}
            {...rest}
        >
            From file
        </span>
    );
}
